'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _createColorPalette = require('./createColorPalette'),
    _createColorPalette2 = _interopRequireDefault(_createColorPalette);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var grass = {
  1: '#21a921',
  2: '#0a870a'
},
    createGrassColorPalette = function createGrassColorPalette() {
  return 'production' !== process.env.NODE_ENV && console.warn('Warning: The grass color palette has been deprecated and will be removed in a future release. The \'green\' palette in colors/green.js will be used in the future.'), (0, _createColorPalette2.default)(grass, 'grass');
};

exports.default = createGrassColorPalette();